export default "__VITE_ASSET__TxovrWEJ__"